import {
  Box,
  FormHelperText,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
} from '@mui/material';
import { ProductSummary } from 'quote-detail/product-summary';
import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useQuoteState } from 'shared/contexts';
import { Brands, Product } from 'shared/types';
import { discountRecommendationBrands, listPriceBrands } from '../shared/constants';

const rootStyles: SxProps<Theme> = {
  width: '100%',
};
const productsStyles: SxProps<Theme> = (theme: Theme) => ({
  marginTop: '20px',
  width: '100%',
  '& .MuiTableRow-head': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiTableCell-head': {
    fontWeight: 'normal',
    '&:nth-of-type(1)': {
      paddingLeft: theme.spacing(5),
    },
  },
});

export function ProductDetails() {
  const { newProduct } = useQuoteState();
  const { brand } = useParams<{ brand: Brands }>();
  const isPartsVsEquipmentAvailable = ['lewis', 'inscoprocess'].includes(brand);
  const isCBEbrand: boolean = brand === 'cbe';
  const isNianticBrand: boolean = brand === 'nianticseal';
  const isDiscountBasedBrand: boolean = discountRecommendationBrands.includes(brand);
  const isListPriceBrand: boolean = listPriceBrands.includes(brand);

  const {
    watch,
    formState: { errors },
  } = useFormContext();
  const { fields, remove, append } = useFieldArray({
    name: 'products',
  });

  const watchProducts = watch('products', []) as Product[];
  const controlledFields = fields.map((field, index) => ({
    ...field,
    ...watchProducts?.[index],
  }));

  useEffect(() => {
    if (newProduct) {
      append(newProduct);
    }
  }, [newProduct, append]);

  return (
    <Box sx={rootStyles}>
      {<FormHelperText error>{errors?.products?.message}</FormHelperText>}
      <Box sx={productsStyles}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align='left'>Product</TableCell>
                <TableCell align='left'>Product Number</TableCell>
                <TableCell align='left'>Product Type</TableCell>
                <TableCell align='left'>Vendor</TableCell>
                {isNianticBrand && <TableCell align='left'>Customer Product Number</TableCell>}
                {isCBEbrand && <TableCell align='left'>Freight Adder</TableCell>}
                {isCBEbrand && <TableCell align='left'>Exchange Rate</TableCell>}
                <TableCell align='left'>Cost</TableCell>
                {isCBEbrand && <TableCell align='left'>Cost Currency</TableCell>}
                {(isDiscountBasedBrand || isListPriceBrand) && <TableCell align='left'>List Price</TableCell>}
                <TableCell align='left'>Quantity</TableCell>
                <TableCell align='left'>Price</TableCell>
                <TableCell align='left'>Total Price</TableCell>
                {isPartsVsEquipmentAvailable && <TableCell align='left'>Parts vs Equipment</TableCell>}
                {isCBEbrand && <TableCell align='left'>Factor Sheet Name</TableCell>}
                <TableCell align='right' />
              </TableRow>
            </TableHead>
            <TableBody>
              {controlledFields.map((product, index) => (
                <ProductSummary key={product.id} product={product} index={index} remove={remove} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}
